export default "__VITE_ASSET__ujYLUxoz__"